import { onMounted, ref } from 'vue'
import { loc } from '@/__core__/localization/localization'

export default function useTabNavigation(tabsTemplate = [], langId = '', initOnMount = false) {
  const tabs = ref([])
  const activeTab = ref(null)

  function changeTab(newTab) {
    activeTab.value = newTab
  }

  function initialize(newTabs) {
    tabs.value = (newTabs || tabsTemplate).map(item => ({ title: loc(item.title || item.name, langId), id: item.id, icon: item.icon }))
    activeTab.value = tabs.value[0]
  }

  onMounted(() => {
    if (initOnMount) {
      initialize()
    }
  })

  return {
    tabs,
    activeTab,
    changeTab,
    initialize
  }
}
